/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, Link, Outlet } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/design-system')({
  component: () => (
    <RouteGuard route="/design-system">
      <DesignSystemLayout />
    </RouteGuard>
  ),
});

const NAV_ITEMS = [
  { to: '/design-system/accordion', label: 'Accordion' },
  { to: '/design-system/alert', label: 'Alert' },
  { to: '/design-system/aspect-ratio', label: 'Aspect Ratio' },
  { to: '/design-system/attachment', label: 'Attachment' },
  { to: '/design-system/avatar', label: 'Avatar' },
  { to: '/design-system/breadcrumb', label: 'Breadcrumb' },
  { to: '/design-system/button', label: 'Button' },
  { to: '/design-system/button-group', label: 'Button Group' },
  { to: '/design-system/calendar', label: 'Calendar' },
  { to: '/design-system/card', label: 'Card' },
  { to: '/design-system/checkbox', label: 'Checkbox' },
  { to: '/design-system/chip', label: 'Chip' },
  { to: '/design-system/collapsible', label: 'Collapsible' },
  { to: '/design-system/combobox', label: 'Combobox' },
  { to: '/design-system/data-table', label: 'Data Table' },
  { to: '/design-system/date-picker', label: 'Date Picker' },
  { to: '/design-system/detail-page-states', label: 'Detail Page States' },
  { to: '/design-system/dialog', label: 'Dialog' },
  { to: '/design-system/dropdown-menu', label: 'Dropdown Menu' },
  { to: '/design-system/editable-cell', label: 'Editable Cell' },
  { to: '/design-system/empty', label: 'Empty' },
  { to: '/design-system/field', label: 'Field' },
  { to: '/design-system/filter-button', label: 'Filter Button' },
  { to: '/design-system/input', label: 'Input' },
  { to: '/design-system/input-group', label: 'Input Group' },
  { to: '/design-system/item', label: 'Item' },
  { to: '/design-system/label', label: 'Label' },
  { to: '/design-system/menubar', label: 'Menubar' },
  { to: '/design-system/nested-table', label: 'Nested Table' },
  { to: '/design-system/radio-group', label: 'Radio Group' },
  { to: '/design-system/resizable', label: 'Resizable' },
  { to: '/design-system/scroll-area', label: 'Scroll Area' },
  { to: '/design-system/select', label: 'Select' },
  { to: '/design-system/separator', label: 'Separator' },
  { to: '/design-system/sheet', label: 'Sheet' },
  { to: '/design-system/sidebar', label: 'Sidebar' },
  { to: '/design-system/spinner', label: 'Spinner' },
  { to: '/design-system/switch', label: 'Switch' },
  { to: '/design-system/table', label: 'Table' },
  { to: '/design-system/tabs', label: 'Tabs' },
  { to: '/design-system/textarea', label: 'Textarea' },
  { to: '/design-system/sonner', label: 'Toast' },
  { to: '/design-system/toggle', label: 'Toggle' },
  { to: '/design-system/toggle-group', label: 'Toggle Group' },
  { to: '/design-system/tooltip', label: 'Tooltip' },
  { to: '/design-system/tree-combobox', label: 'Tree Combobox' },
  { to: '/design-system/tree-table', label: 'Tree Table' },
  { to: '/design-system/wizard', label: 'Wizard' },
] as const;

function DesignSystemLayout() {
  return (
    <div className="flex gap-8">
      <nav className="w-44 shrink-0">
        <p className="mb-2 px-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          Components
        </p>
        <ul className="flex flex-col gap-0.5">
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className="block rounded-md px-2 py-1.5 text-sm text-foreground no-underline transition-colors hover:bg-accent"
                activeProps={{
                  className:
                    'block rounded-md px-2 py-1.5 text-sm no-underline transition-colors bg-accent font-medium',
                }}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
